import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { chevronForward } from 'ionicons/icons';

@Component({
  selector: 'x-settings-item',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonIcon],
  templateUrl: './x-settings-item.component.html',
  styleUrl: './x-settings-item.component.scss',
})
export class XSettingsItemComponent {
  title = input.required<string>();
  subtitle = input<string>();
  iconName = input.required<string>();
  showChevron = input(true);
  isDestructive = input(false);
  isLast = input(false);

  pressed = output<void>();

  constructor() {
    addIcons({ chevronForward });
  }
}
